"use client";

import React, { Dispatch, FC, ReactNode, createContext, useCallback, useState } from "react";

interface SelectUnitProps {
  card: { unitType: string; categoryID: string } | undefined;
  setCard: Dispatch<{ unitType: string; categoryID: string } | undefined>;
  unitTitle: string;
  updateUnitTitle: (title: string) => void;
}
interface Props {
  children: ReactNode;
}

export const SelectUnitContext = createContext<SelectUnitProps>({
  card: undefined,
  setCard: () => {},
  unitTitle: "",
  updateUnitTitle: (title: string) => {},
});

interface Props {
  children: ReactNode;
}

const SelectUnitContextProvider: FC<Props> = ({ children }) => {
  const [card, setCard] = useState<{ unitType: string; categoryID: string }>();
  const [unitTitle, setUnitTitle] = useState<string>("");

  const updateUnitTitle = useCallback((title: string) => {
    setUnitTitle(title);
  }, []);

  return (
    <SelectUnitContext.Provider
      value={{
        card,
        setCard,
        unitTitle,
        updateUnitTitle,
      }}
    >
      {children}
    </SelectUnitContext.Provider>
  );
};
export default SelectUnitContextProvider;
